// Os mesmos tokens de tokens.css, para quem precisa da cor no código (SVG, canvas).
export const cores = {
  ground900: '#071811',
  ground800: '#0C241A',
  ground700: '#133627',
  line600: '#2A4A3B',
  felt500: '#17684B',
  felt700: '#0E4532',
  wood500: '#6B4325',
  wood700: '#3E2614',
  gold400: '#F2C14E',
  gold600: '#B8862B',
  fire500: '#FC6B15',
  fire700: '#C4500A',
  cream050: '#FFF3D6',
  nos400: '#27D3C3',
  eles400: '#FF5D57',
  ink050: '#F5EFE1',
  ink200: '#CFD7CC',
  ink300: '#A9BBAF',
  ink600: '#4A4438',
  ink800: '#211D16',
  ink900: '#14110C',
  paper: '#FBF8F1',
  paper2: '#F1EBDD',
  paperLine: '#DDD3BF',
  gold800: '#8A4B06',
  suitRed: '#C8102E',
  paperManilha: '#F2C14E',
  manilhaEdge: '#8A4B06',
  suitRedManilha: '#A30B24',
  aparelho900: '#0B0F0D',
  sponsor500: '#E8631A',
  sponsor300: '#FFC93C',
  prata300: '#C9D1D6',
  prata600: '#7E888E',
  bronze400: '#C98B5A',
  bronze700: '#7A4A2A',
  vitoria500: '#2E9E5B',
  derrota500: '#E0474C',
  marcaCreme: '#F6EFDB',
  marcaVerde: '#032015',
  marcaFundo: '#072318',
} as const;

export const fontes = {
  display: '"Barlow Condensed", "Arial Narrow", sans-serif',
  ui: '"Barlow", "Segoe UI", sans-serif',
} as const;

// Fontes do Google usadas no jogo (o único lugar de onde carregamos folhas de estilo de fora).
export const URL_FONTES = 'https://fonts.googleapis.com/css2?family=Barlow:wght@500;600;700;800&family=Barlow+Condensed:wght@700;800&display=swap';
